export const openApp = () => {
  const openLink = 'https://app-api.zjol.com.cn'
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = openLink;
  document.body.appendChild(a);
  const ev = new MouseEvent("click");
  a.dispatchEvent(ev);
  // const now = Date.now();
  // const o = setTimeout(() => {
  //   if (document.hidden || document.webkitHidden) {
  //     clearTimeout(o);
  //   } else if (Date.now() - now > 3503) {
  //     clearTimeout(o);
  //   } else {
  //     window.location.href = openLink;
  //   }
  // }, 2000);
}

export const jsdk = (shareData) => {
  let zjrbCp = document.createElement('script')
      zjrbCp.async = 'async'
      zjrbCp.src = 'https://activity.tianmunews.com/material/tmWebJssdk/tmJsSdk.js'
      zjrbCp.charset = 'UTF-8'
      document.body.appendChild(zjrbCp)
      window.jssdknum = 1
      zjrbCp.onload = function () {
        if (window.CP && typeof window.CP.ready === 'function') {
          window.CP.ready({
            debug: false, //可选，是否是开启调试模式, 默认false
            es6Require: false, //可选，是否需要加载es6库，默认false
            wxOption: {
              //可选，内容需要二次分享时请配置此项
              debug: false, //是否是开启微信调试模式
              appid: 'wx0511ad48925f257e', //授权的微信公众号的appid  微信二次分享使用，具体使用方式请参照 附录：微信及微信二次分享
              method: 'getShareSign', //获取微信信息方法，写死
              // uploadImage: '', //使用微信录音，图片上传等功能时需要的上传后台服务器地址
              redirect: location.href.split('#')[0], //回调域名，一般为加载后签名时页面，如跳转可能会签名失败 附录：微信及微信二次分享
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'startRecord',
                'stopRecord',
                'onVoiceRecordEnd',
                'onVoicePlayEnd',
                'uploadVoice',
                'playVoice',
                'getLocation',
                'chooseImage',
                'uploadImage',
                'stopVoice',
                'pauseVoice',
                'previewImage',
                'translateVoice',
                'updateAppMessageShareData',
                'updateTimelineShareData',
              ], // 分享到微信必填，需要使用的微信JS接口列表，所有JS接口列表见 附录：微信JS接口列表
              openTagList: ['wx-open-launch-app'],
            },
            ready: function (client_info) {
              console.log("-----------**********---------")
              window.CP.setShare({
                completed: function (data) {
                  // console.log(data)
                },
                imgUrl: shareData.imgUrl,
                link: shareData.link,
                title: shareData.title,
                shareSummary: shareData.summary
              })
              //jssdk加载完成调用此方法
              console.log('设置分享')
              isZjolapp()
              //client_info > { client_code: 'web', version: '1.0', detail: ''}  clientInfo 接口返回数据
              
            },
            error: function (error) {
              console.log(error)
              //jssdk运行时报错，但不会阻断程序运行  427569
              //error > {code: 4000, msg: res.errMsg, data: res}  res为原生报错 微信的报错也在这处理
            },
          })
        }
      }
}